export default function useCopyToClipboard() {
    function isNotAvailable(): boolean {
        if (typeof navigator === 'undefined') {
            return true
        }

        return navigator.clipboard === undefined
    }

    function copy(
        content: string,
        successCallback: Function = () => {},
        errorCallback: Function = () => {},
    ): void {
        if (typeof navigator === 'undefined' || !navigator.clipboard) {
            errorCallback()

            return
        }

        navigator.clipboard
            ?.writeText(content)
            .then(() => {
                successCallback()
            })
            .catch(() => {
                errorCallback()
            })
    }

    return {
        isNotAvailable,
        copy,
    }
}
